<div class="app-shell" [attr.inert]="disclaimerInteractionLocked ? '' : null">
  @if (showSidebar) {
    <app-base-sidebar
      [logoUrl]="sidebarConfig.logoUrl"
      [logoCompactUrl]="sidebarConfig.logoCompactUrl"
      [companyName]="sidebarConfig.companyName"
      [tagline]="sidebarConfig.tagline"
      [taglineShort]="sidebarConfig.taglineShort">
      <app-toolbar></app-toolbar>
      <router-outlet />
      <app-footer></app-footer>
    </app-base-sidebar>
  } @else {
    <router-outlet />
  }
</div>

@if (disclaimerInteractionLocked) {
  <div class="disclaimer-interaction-lock" aria-hidden="true"></div>
}
